import { radiusVars, spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';

const PLAIN_MAX_WIDTH = 440;

export const containerClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: spacingVars['3xl'],
});

export const cardSurfaceClass = style({
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  padding: `${spacingVars['4xl']} ${spacingVars['3xl']}`,
  borderRadius: radiusVars.xl,
});

export const plainSurfaceClass = style({
  maxWidth: PLAIN_MAX_WIDTH,
});

export const fullWidthClass = style({
  maxWidth: 'none',
  width: '100%',
});

export const illustrationClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

export const contentClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacingVars.lg,
});

export const textBlockClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacingVars.xs,
});

export const titleClass = style({
  margin: 0,
  color: semanticTokenVars.content.default.default,
});

export const descriptionClass = style({
  margin: 0,
  color: semanticTokenVars.content.muted.default,
});
